import 'angular:locale/data:nl';
import './src/polyfills.ts';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "nl";
